// src/socket/socket.js
import { io } from "socket.io-client";

const serverURL = process.env.REACT_APP_URL;

const socket = io(serverURL);

export default socket;
